import React, { useState } from 'react'
import style from './createProjectManager.module.scss'
import { ITmpPerson } from '../../starter/model/interfaces'
import { DatePicker, Input, Radio } from 'antd'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { useActions } from '../../starter/hooks/actions'
import { useAppSelector } from '../../starter/hooks/redux'
import dayjs, { Dayjs } from 'dayjs'
import TextArea from 'antd/es/input/TextArea'
import validator from 'validator'

dayjs.extend(customParseFormat)

export default function CreateProjectManager() {
  const { setTmpProjectManager } = useActions()
  const { projectManager, apiError } = useAppSelector((state) => state.tmp)
  const [formErrors, setFormErrors] = useState({ firstName: '', lastName: '', email: '', birthDay: '', phone: '' })
  const handleInputChange = (evt: any): void => {
    if (evt.target) {
      const { name, value } = evt.target
      const _person: ITmpPerson = personValidate({
        ...projectManager,
        [name]: value
      })
      setTmpProjectManager(_person)
    }
  }

  const handleInputChangeDate = (name: string, date: Dayjs, dateString: string | string[]): void => {
    const _person = personValidate({
      ...projectManager,
      [name]: date && date.toDate()
    })
    setTmpProjectManager(_person)
  }

  const personValidate = (person: ITmpPerson): ITmpPerson => {
    let isValid = true
    let errors: any = {}
    Object.keys(person).forEach((key) => {
      switch (key) {
        case 'firstName':
          if (person[key].length < 2) {
            isValid = false
            errors[key] = 'Имя должно содержать не менее двух символов'
          } else if (!validator.matches(person[key], /^[0-9-A-Za-zА-Яа-яЁё\s-]{2,30}$/)) {
            isValid = false
            errors[key] = 'Имя должно содержать только латиницу, кириллицу, пробел, дефис или цифры'
          }
          break
        case 'lastName':
          if (person[key].length < 2) {
            isValid = false
            errors[key] = 'Фамилия должна содержать не менее двух символов'
          } else if (!validator.matches(person[key], /^[0-9-A-Za-zА-Яа-яЁё\s-]{2,30}$/)) {
            isValid = false
            errors[key] = 'Фамилия должна содержать только латиницу, кириллицу, пробел, дефис или цифры'
          }
          break
        case 'birthDay':
          if (!person[key]) {
            isValid = false
            errors[key] = 'Заполните день рождения'
          }
          break
        case 'email':
          if (person[key]) {
            // @ts-ignore
            if (person[key].length < 5 && person[key].length > 30) {
              isValid = false
              errors[key] = 'Email должен содержать от 5 до 30 символов'
              // @ts-ignore
            } else if (!validator.isEmail(person[key])) {
              isValid = false
              errors[key] = 'Введите корректный email'
            }
          }
          break
        case 'phone':
          if (person[key]) {
            // @ts-ignore
            if (person[key].length < 10 && person[key].length > 11) {
              isValid = false
              errors[key] = 'Email должен содержать от 10 до 11 символов'
              // @ts-ignore
            } else if (!validator.isMobilePhone(person[key])) {
              isValid = false
              errors[key] = 'Введите корректный номер телефона'
            }
          }
          break
        default:
          break
      }
    })
    setFormErrors(errors)
    return {
      ...person,
      validate: {
        isValid,
        message: Object.keys(errors).map((key) => errors[key]),
        showError: person.validate?.showError || false
      }
    }
  }

  return (
    <div className={style.wrapper}>
      <label className={style.inputLabel}>
        Имя
        <Input
          className={style.input}
          name='firstName'
          placeholder='Имя'
          value={projectManager.firstName}
          onChange={handleInputChange}
        />
        {formErrors.firstName && projectManager.validate.showError && (
          <div className={`${formErrors.firstName ? style.inputError : ''}`}>{formErrors.firstName}</div>
        )}
      </label>
      <label className={style.inputLabel}>
        Фамилия
        <Input
          className={style.input}
          name='lastName'
          placeholder='Фамилия'
          value={projectManager.lastName}
          onChange={handleInputChange}
        />
        {formErrors.lastName && projectManager.validate.showError && (
          <div className={`${formErrors.lastName ? style.inputError : ''}`}>{formErrors.lastName}</div>
        )}
      </label>
      <label className={style.inputLabel}>
        Отчество
        <Input
          className={style.input}
          name='middleName'
          placeholder='Отчество'
          value={projectManager.middleName}
          onChange={handleInputChange}
        />
      </label>
      <label className={style.inputLabel}>
        День рождения
        <br />
        <DatePicker
          style={{ margin: '0.5rem 0' }}
          name='birthDay'
          value={projectManager.birthDay && dayjs(projectManager.birthDay)}
          onChange={(date, dateString) => {
            handleInputChangeDate('birthDay', date, dateString)
          }}
        />
        {formErrors.birthDay && projectManager.validate.showError && (
          <div className={`${formErrors.birthDay ? style.inputError : ''}`}>{formErrors.birthDay}</div>
        )}
      </label>
      <br />
      <label className={style.inputLabel}>
        <Radio.Group style={{ margin: '0.5rem 0' }} name='sex' value={projectManager.sex} onChange={handleInputChange}>
          <Radio.Button value='male'>Муж</Radio.Button>
          <Radio.Button value='female'>Жен</Radio.Button>
        </Radio.Group>
      </label>
      <br />
      <label className={style.inputLabel}>
        email
        <Input
          className={style.input}
          name='email'
          placeholder='email'
          value={projectManager.email}
          onChange={handleInputChange}
        />
        {formErrors.email && projectManager.validate.showError && (
          <div className={`${formErrors.email ? style.inputError : ''}`}>{formErrors.email}</div>
        )}
      </label>
      <label className={style.inputLabel}>
        Телефон
        <Input name='phone' placeholder='Телефон' value={projectManager.phone} onChange={handleInputChange} />
        {formErrors.phone && projectManager.validate.showError && (
          <div className={`${formErrors.phone ? style.inputError : ''}`}>{formErrors.phone}</div>
        )}
      </label>
      <label className={style.inputLabel}>
        Телеграм
        <Input
          className={style.input}
          name='telegram'
          placeholder='Телеграм'
          value={projectManager.telegram}
          onChange={handleInputChange}
        />
      </label>
      <label className={style.inputLabel}>
        Комментарий
        <TextArea
          rows={4}
          value={projectManager.comment}
          name='comment'
          placeholder='Комментарий'
          onChange={handleInputChange}
        />
      </label>
      {apiError.isError && (
        <p className={style.errorMessage}>
          {typeof apiError.message === 'object' ? JSON.stringify(apiError.message) : apiError.message}
        </p>
      )}
    </div>
  )
}
